


import React from 'react';
import { Box, Card, Divider, TableBody, Checkbox, ListItemText, } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Avatar from "../../../icons/Avatar.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import Autocomplete from '@mui/material/Autocomplete';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

export default function PowerBIPermissions() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // function setPage(pageNumber) {}

    const [open, setOpen] = useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const [state, setSate] = useState(false);

    const [Tab, setTab] = React.useState("");
    const [PowerBiUsers, setPowerBiUsers] = React.useState([]);
    const [Count, setCount] = React.useState("");
    const [PowerBiReportNames, setPowerBiReportNames] = React.useState([]);
    const [PowerBiReportNameId, setPowerBiReportNameId] = React.useState("");
    const [PBRNameId, setPBRNameId] = React.useState("");
    const [number, setNumber] = React.useState("1");
    const [orgType, setOrgType] = useState("0");

    const [id, setID] = useState("");

    const [search, setSearch] = React.useState("");

    const [Companies, setCompanies] = React.useState([]);
    const [Comid, setComID] = useState("0");

    const [OrganizationUsers, setOrganizationUsers] = React.useState([]);
    const [OrganizationUsersIds, setOrganizationUsersIds] = React.useState([]);

    const Orglist = [{
        "value": "0",
        "text": "All"
    }, {
        "value": "1",
        "text": "Admin"
    }, {
        "value": "2",
        "text": "Client"
    }, {
        "value": "3",
        "text": "Vendor"
    }]


    const handleClickOpen = (num, r) => {
        setTab(num);
        setID(num == 2 || num == 3 ? r?.id : 0);
        ChangeOrg(num == 2 ? r?.permissionType?.toString() : "0");
        ChangeComp(num == 2 ? r?.orgId == null ? "0" : r?.orgId : "0");
        setPowerBiReportNameId(num == 2 ? r?.reportId : PBRNameId);
        setOrganizationUsersIds(num == 2 ? r?.userId.split(",") : []);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        Details();
        axios.get("SystemUser/GetPowerBiReportNames")
            .then((res) => {
                setPowerBiReportNames(res?.data?.data);
                setPBRNameId(res?.data?.data[0]?.value);
            }).catch(err => {
                console.log(err);
            })
        // axios.get("SystemUser/GetDetailsToAddUser")
        //     .then((res) => {
        //         setOrgList(res?.data?.data?.orgTypes);
        //     }).catch(err => {
        //         console.log(err);
        //     })
    }, []);

    const ChangeOrg = async (e) => {
        setOrgType(e);
        const response = await axios.get("SystemUser/GetOrganizationsList?userType=" + e);
        setCompanies(response?.data?.data);


    }
    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        Details();
    }, [number, search]);
    async function Details() {
        setSpinner(!spinner);
        axios.get("SystemUser/GetPowerBiUsers?pagesize=" + 12 + "&pageNumber=" + number + "&reportName=" + search)
            .then((res) => {
                setPowerBiUsers(res?.data?.data);
                setCount(res?.data?.count);
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                setSpinner(false);
            })
    }


    const ChangeComp = async (e) => {
        setComID(e);
        const response = await axios.get("SystemUser/GetOrganizationUsers?orgId=" + e);
        setOrganizationUsers(response?.data?.data);
    }


    const handlePageChange = (e) => {
        setNumber(e);
        // Details();
    };
    const SendPermission = async () => {
        // const Data = {
        //     "id": id,
        //     "orgName": CompNames,
        //     "orgId": Comid,
        //     "reportId": PowerBiReportNameId,
        //     "permissionTo": PerType,
        //     "permissionType": orgType,
        //     "reportName": ReName,
        //     "users": users?.toString(),
        //     "userId": OrganizationUsersIds?.toString()
        // }

        if (Tab == 1 || Tab == 2) {
            setSate(true);
            // const ReName = PowerBiReportNames?.find((r) => r?.value == PowerBiReportNameId)?.key;
            // const PerType = Orglist?.find((r) => r?.value == orgType)?.text;
            // const CompNames = Companies?.find((r) => r?.value == Comid)?.text;
            // const users = OrganizationUsers?.filter((r) => OrganizationUsersIds?.indexOf(r?.userId) != -1)?.map(r => r.name);
            const Data = {
                "id": id,
                "orgId": orgType == "0" ? null : Comid == "0" ? null : Comid,
                "reportId": PowerBiReportNameId,
                "permissionType": orgType,
                "userId": orgType == "0" || Comid == "0" ? "" : OrganizationUsersIds?.toString()
            }
            axios.post("SystemUser/PostPowerBiUsersData", Data)
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        handleClose();
                        toastNotify(res?.data?.responseMessage, true);
                        setNumber("1");
                        Details();
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setSate(false);
                });
        } else {
            const res = await axios.post("SystemUser/DeletePowerBiUserPermission?id=" + id);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                setNumber("1");
                Details();
                handleClose();
            } else {
                toastNotify(res?.data?.responseMessage, false);
                setSate(false);
            }
        }
    }



    return (
        <>
            <Card>
                <ToastContainer />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={spinner}
                    onClick={SpinnerClose}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                    <DialogContent sx={{ padding: "48px 48px" }}>
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 500,
                                fontSize: 20,
                            }}
                        >
                            <span style={{ fontSize: "larger" }} >{Tab == 3 ? "Delete Power BI Permission" : Tab == 1 ? " Add Power BI Permission" : " Edit Power BI Permission"}</span>
                        </DialogTitle>

                        <DialogActions >
                            <div>
                                {Tab == 3 ?
                                    "Do you want to delete this Permission?"
                                    :
                                    <div className=''>
                                        <div>
                                            <span style={{ color: "#3E4A62" }}>Report Name   <span style={{ color: "red" }}>*</span></span>
                                            <br />

                                            <Select
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "320px"
                                                }}
                                                labelId="demo-multiple-name-label"
                                                value={PowerBiReportNameId || ""}
                                                id="demo-multiple-name"
                                                size="small"
                                                disabled={Tab == 2}
                                                onChange={(e) => setPowerBiReportNameId(e.target.value)}
                                                MenuProps={MenuProps}
                                            >
                                                {PowerBiReportNames?.map((r, i) =>
                                                    <MenuItem key={i} value={r?.value}>{r?.key}</MenuItem>
                                                )}

                                            </Select>

                                        </div>
                                        <div className='mt-3'>
                                            <span style={{ color: "#3E4A62" }}>User Organization Type</span>
                                            <br />

                                            <Select
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "320px"
                                                }}
                                                labelId="demo-multiple-name-label"
                                                value={orgType || ""}
                                                id="demo-multiple-name"
                                                size="small"
                                                onChange={(e) => ChangeOrg(e.target.value)}
                                                MenuProps={MenuProps}
                                            >
                                                {Orglist?.map((r, index) => (
                                                    <MenuItem key={index} value={r?.value}>
                                                        {r?.text}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                        </div>
                                        <div className='mt-3' style={{ display: orgType == "0" ? "none" : "block" }}>
                                            <span style={{ color: "#3E4A62" }}>Company <span style={{ color: "red" }}>*</span></span>
                                            <br />
                                            <Select
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "320px"
                                                }}
                                                labelId="demo-multiple-name-label"
                                                value={Comid || ""}
                                                id="demo-multiple-name"
                                                size="small"
                                                onChange={(e) => ChangeComp(e.target.value)}
                                                MenuProps={MenuProps}
                                            >
                                                <MenuItem key={0} value={"0"} >All</MenuItem>
                                                {Companies?.map((r, index) => (
                                                    <MenuItem key={index} title={r?.text} value={r?.value}>
                                                        {r?.text}
                                                    </MenuItem>
                                                ))}

                                            </Select>
                                        </div>

                                        <div className='mt-3' style={{ display: orgType == "0" || Comid == "0" ? "none" : "block" }}>
                                            <span style={{ color: "#3E4A62" }}>Users</span>
                                            <br />
                                            <Select
                                                labelId="docs-label"
                                                id="docs-select"
                                                multiple
                                                size='small'
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "320px",
                                                }}
                                                name="Site Safety Representive"
                                                value={OrganizationUsersIds || []}
                                                MenuProps={MenuProps}
                                                renderValue={(selected) =>
                                                    selected
                                                        .map((value) => OrganizationUsers?.find((doc) => doc?.userId === value)?.name)
                                                        .filter((text) => text !== undefined)
                                                        .join(", ")
                                                }
                                                onChange={(e) => setOrganizationUsersIds(e.target.value)}
                                            >
                                                {/* <MenuItem key="Select All">
                                                    <Checkbox
                                                        indeterminate={
                                                            OrganizationUsersIds?.length > 0 && OrganizationUsersIds?.length < OrganizationUsers?.length
                                                        }
                                                        checked={OrganizationUsersIds?.length === OrganizationUsers?.length}
                                                        onChange={(event) => {
                                                            if (event?.target?.checked) {
                                                                setOrganizationUsersIds(OrganizationUsers?.map((doc) => doc?.userId));
                                                            } else {
                                                                setOrganizationUsersIds([]);
                                                            }
                                                        }}
                                                    />
                                                    <ListItemText primary="Select All" />
                                                </MenuItem> */}

                                                {OrganizationUsers?.map((r, i) => (
                                                    <MenuItem key={i} value={r?.userId}>
                                                        <Checkbox checked={OrganizationUsersIds?.indexOf(r?.userId) > -1} />
                                                        <ListItemText primary={r?.name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </div>

                                    </div>
                                }
                                <DialogActions >
                                    <div className="login-help__buttonContainer mt-4">
                                        <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                        <Button variant="contained" className="login-button-request mx-2" onClick={SendPermission} disabled={state == true}>{Tab == 3 ? "Ok" : Tab == 1 ? "Add " : "Save"}</Button>
                                    </div>

                                </DialogActions>
                            </div >
                        </DialogActions>



                    </DialogContent>
                </Dialog>

                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <Stack spacing={2} direction="row">
                            <h3> Power BI Permissions</h3>
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                {HasPermissions(INFO?.AddPowerBiPermissions?.actionName, PER?.ScreenPermissions?.Insert) &&
                                    <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                                }
                            </div>
                        </Stack >
                    </div>
                </div>

                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>

                    <TextField
                        placeholder='Search'
                        sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            fontFamily: "Arial, FontAwesome"
                        }}
                        value={search}
                        onChange={(e) => setSearch(e?.target?.value)}
                        variant="outlined"
                        size="small"

                    />

                </div>
                {PowerBiUsers?.length == 0 ? <Box hidden={spinner} border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                    <span style={{ color: "#667085" }}>Record Not Found</span>
                </Box> : <>
                    <Box sx={{ backgroundColor: '#f8f9fa' }}>

                        <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                            <Table aria-label="customized table">

                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Report Name</span>	</StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Organization Type</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Organization</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Users</span></StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>

                                    </TableRow>
                                </TableHead>


                                {PowerBiUsers?.map((r, i) => (
                                    <TableBody key={i}>

                                        <TableRow key={i} >

                                            <StyledTableCell sx={{ width: "25%" }}>
                                                {r?.reportName}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "25%" }} >
                                                {r?.permissionTo}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "25%" }} >
                                                {r?.orgName}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "25%" }} >
                                                {r?.users}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "5%" }} >
                                                {HasPermissions(INFO?.AddPowerBiPermissions?.actionName, PER?.ScreenPermissions?.Modify) &&
                                                    <IconButton aria-label="edit" onClick={() => handleClickOpen(2, r)}>
                                                        <img src={Edit} alt="editicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "20%" }}>
                                                {HasPermissions(INFO?.AddPowerBiPermissions?.actionName, PER?.ScreenPermissions?.Delete) &&
                                                    <IconButton aria-label="delete" onClick={() => handleClickOpen(3, r)}>
                                                        <img src={Trash} alt="trashicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>

                                        </TableRow>

                                    </TableBody>
                                ))}
                            </Table>

                        </TableContainer>
                    </Box >
                </>}
            </Card>
            <div hidden={PowerBiUsers?.length == 0}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}



